/* Copyright (c) 2019-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */
import { generateUuid } from 'utils/lib/common/common-utils';
import { Plugin } from '../common/plugin';

/**
 * An abstract base class for browser implementation of a bridge command.
 */
export abstract class BrowserPlugin extends Plugin {
    private static _browserInstanceId = generateUuid(true);

    protected static get browserInstanceId(): string {
        return this._browserInstanceId;
    }
}
